import type { PortalLang } from '@/lib/lang';

/**
 * The words of a prospect's home (someone still looking, from the front door):
 * the greeting, what living there includes, the office, the next step and the
 * way out. A resident's home, the registration and the lease stay Hebrew.
 */
export interface HomeStrings {
  hello: (name: string | null) => string;
  included: string;
  team: string;
  signOut: string;
  next: {
    checkFailed: string;
    retry: string;
    signTitle: string;
    signBody: string;
    signButton: string;
    signedTitle: string;
    signedOffline: string;
    signedView: string;
    waiting: string;
  };
}

export const HOME_STRINGS: Record<PortalLang, HomeStrings> = {
  he: {
    hello: (name) => (name ? `שלום ${name}` : 'שלום'),
    included: 'מה כלול במגורים',
    team: 'צוות הדיור',
    signOut: 'יציאה',
    next: {
      checkFailed: 'לא הצלחנו לבדוק אם ממתין לך חוזה לחתימה.',
      retry: 'נסו שוב',
      signTitle: 'השלב הבא: חתימה על חוזה השכירות',
      signBody: 'החוזה שלך מחכה לחתימה דיגיטלית. זה לוקח כדקה.',
      signButton: 'קריאה וחתימה על החוזה',
      signedTitle: 'חוזה השכירות שלך נחתם',
      signedOffline: 'נחתם מול צוות הדיור',
      signedView: 'לצפייה ולהורדת העותק החתום',
      waiting: 'השלב הבא: צוות הדיור ישלח לך את חוזה השכירות לחתימה דיגיטלית. ההודעה תגיע למייל שלך.',
    },
  },
  ar: {
    hello: (name) => (name ? `مرحبًا ${name}` : 'مرحبًا'),
    included: 'ما يشمله السكن',
    team: 'فريق السكن',
    signOut: 'تسجيل الخروج',
    next: {
      checkFailed: 'تعذّر التحقق مما إذا كان هناك عقد بانتظار توقيعكم.',
      retry: 'حاولوا مرة أخرى',
      signTitle: 'الخطوة التالية: توقيع عقد الإيجار',
      signBody: 'عقدكم بانتظار التوقيع الرقمي. يستغرق ذلك نحو دقيقة.',
      signButton: 'قراءة العقد وتوقيعه',
      signedTitle: 'تم توقيع عقد الإيجار الخاص بكم',
      signedOffline: 'وُقّع مع فريق السكن',
      signedView: 'لعرض النسخة الموقّعة وتنزيلها',
      waiting:
        'الخطوة التالية: سيرسل إليكم فريق السكن عقد الإيجار للتوقيع الرقمي. ستصلكم الرسالة إلى بريدكم الإلكتروني.',
    },
  },
  en: {
    hello: (name) => (name ? `Hello ${name}` : 'Hello'),
    included: "What's included",
    team: 'Housing team',
    signOut: 'Sign out',
    next: {
      checkFailed: 'We could not check whether a lease is waiting for you.',
      retry: 'Try again',
      signTitle: 'Next: sign your lease',
      signBody: 'Your lease is waiting for a digital signature. It takes about a minute.',
      signButton: 'Read and sign the lease',
      signedTitle: 'Your lease is signed',
      signedOffline: 'Signed with the housing team',
      signedView: 'View and download the signed copy',
      waiting: 'Next: the housing team will send you the lease to sign digitally. It will come to your email.',
    },
  },
};
